import * as _ from 'lodash';

export const getImagesFromProductByVariant = (product: GQL.IProduct, variant: GQL.IProductVariant) => {
    return product.images && product.images.sort((a: any, b: any) => {
        return a.priority > b.priority
            ? 1
            : -1;
    });
};



// WEBPACK FOOTER //
// ./src/helpers/getImagesFromProductByVariant.ts